import React from 'react';
import {Edit, SimpleForm} from 'react-admin';

import {CustomToolbar, Grid} from '../../components'
import KiotConfigFields from './KiotConfigFields'

export const KiotConfigEdit = props => (
    <Edit {...props}>
        <SimpleForm toolbar={<CustomToolbar/>}>
            <Grid container spacing={8}>
                <KiotConfigFields/>
            </Grid>
        </SimpleForm>
    </Edit>
);

export default KiotConfigEdit
